/* eslint-disable no-useless-catch */
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { toast } from "ToastAlertContainer";

const deletePortfolioInvite = async ({ portfolioId, portfolioInviteId }) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(
    `/api/v2/portfolios/${portfolioId}/invites/${portfolioInviteId}`,
    pathAndHost
  );

  let deletePortfolioInvite;
  try {
    deletePortfolioInvite = await axios.delete(url);
  } catch (err) {
    console.error(err.response.data);
    throw err;
  }

  return deletePortfolioInvite.data;
};

export default function useDeletePortfolioInvite() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ portfolioId, portfolioInviteId }) =>
      await deletePortfolioInvite({
        portfolioId,
        portfolioInviteId,
      }),
    {
      onMutate: async ({ portfolioId, portfolioInviteId }) => {
        await queryClient.cancelQueries(["portfolios", portfolioId, "invites"]);

        const previousPortfolioInvites = queryClient.getQueryData([
          "portfolios",
          portfolioId,
          "invites",
        ]);

        let optimisticPortfolioInvites = previousPortfolioInvites.filter(
          (portfolioInvite) => {
            if (portfolioInvite.portfolio_invite_id !== portfolioInviteId) {
              return true;
            } else {
              return false;
            }
          }
        );

        queryClient.setQueryData(
          ["portfolios", portfolioId, "invites"],
          optimisticPortfolioInvites
        );

        return {
          previousPortfolioInvites,
          optimisticPortfolioInvites,
          portfolioId,
        };
      },
      onError: (err, portfolioInvite, context) => {
        queryClient.setQueryData(
          ["portfolios", context.portfolioId, "invites"],
          context.previousPortfolioInvites
        );
      },
      onSettled: (deletedPortfolioInvite) => {
        let portfolioId = deletedPortfolioInvite.portfolio_id;

        queryClient.invalidateQueries(["portfolios", portfolioId, "invites"]);
      },
    }
  );
}
